<template>
  <div>
    <el-dialog
      :visible.sync="dialogCodeVisible"
      top="2%"
      width="1100px"
      @close="handleClose"
    >
      <span slot="title">创建处方</span>
      <div class="create-content" v-loading="loading">
        <div class="create-left">
          <div class="create-left-title">识别结果</div>
          <div class="create-left-content">
            <el-form
              ref="formRef"
              :model="formData"
              :rules="rules"
              label-width="70px"
              label-position="left"
            >
              <div class="create-left-content-item">
                <div class="create-left-content-item-value">
                  <el-form-item label="处方类型" prop="issueType">
                    <el-input
                      v-model="formData.issueType"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">基础医疗信息</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="开方机构" prop="issueHospital">
                    <el-input
                      v-model="formData.issueHospital"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="处方编号" prop="number">
                    <el-input
                      v-model="formData.number"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="开具时间" prop="issueTime">
                    <el-input
                      v-model="formData.issueTime"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="科别" prop="department">
                    <el-input
                      v-model="formData.department"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="诊断" prop="diagnose">
                    <el-input
                      v-model="formData.diagnose"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">用药人信息</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="姓名" prop="userName">
                    <el-input
                      v-model="formData.userName"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="性别" prop="userSex">
                    <el-input
                      v-model="formData.userSex"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="年龄" prop="userAge">
                    <el-input
                      v-model="formData.userAge"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">
                  <div>药品信息</div>
                  <div class="content-item-title-page" v-if="isUpload">
                    当前第<span style="color: #4076f2">{{ currentPage }}</span
                    >条，共<span style="color: #4076f2">{{ drugTotal }}</span
                    >条
                  </div>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="药品名称" prop="drugName">
                    <el-input
                      v-model="formData.drugName"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="制剂规格" prop="drugSpecification">
                    <el-input
                      v-model="formData.drugSpecification"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="数量" prop="count">
                    <el-input
                      v-model="formData.count"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="用法用量" prop="usage">
                    <el-input
                      v-model="formData.usage"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-page" v-if="isUpload">
                  <el-pagination
                    background
                    layout="pager"
                    :page-size="1"
                    :total="drugTotal"
                    :current-page.sync="currentPage"
                    @current-change="handleCurrentChange"
                  ></el-pagination>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">注意事项</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="注意事项" prop="notes">
                    <el-input
                      v-model="formData.notes"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="create-right">
          <div class="create-right-title">
            <span style="color: #ff3737">*</span>
            <span>文件上传</span>
          </div>
          <DocumentUpload
            ref="DocumentUploadRef"
            @loading="loading = $event"
            @successDelete="handleSuccessDelete"
            @successUpload="handleSuccessUpload"
          ></DocumentUpload>
        </div>
      </div>
      <div class="create-button">
        <el-button plain size="mini" @click="dialogCodeVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="mini" @click="handleSubmit"
          >创建</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DocumentUpload from "@/components/DocumentUpload/index.vue";

export default {
  name: "CreatePrescription",
  components: {
    DocumentUpload,
  },
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      isUpload: false,
      formData: {
        issueType: "",
        issueHospital: "",
        number: "",
        issueTime: "",
        department: "",
        diagnose: "",
        drugName: "",
        drugSpecification: "",
        count: "",
        usage: "",
        userName: "",
        userSex: "",
        userAge: "",
        notes: "",
      },
      drugTotal: 0,
      currentPage: 1,
      rules: {
        issueType: [{ required: true, message: "", trigger: "blur" }],
        issueHospital: [{ required: true, message: "", trigger: "blur" }],
        number: [{ required: true, message: "", trigger: "blur" }],
        issueTime: [{ required: true, message: "", trigger: "blur" }],
        department: [{ required: true, message: "", trigger: "blur" }],
        diagnose: [{ required: true, message: "", trigger: "blur" }],
        drugName: [{ required: true, message: "", trigger: "blur" }],
        drugSpecification: [{ required: true, message: "", trigger: "blur" }],
        count: [{ required: true, message: "", trigger: "blur" }],
        usage: [{ required: true, message: "", trigger: "blur" }],
        userName: [
          { required: true, message: "请输入用药人姓名", trigger: "blur" },
        ],
        userSex: [
          { required: true, message: "请输入用药人性别", trigger: "blur" },
        ],
        userAge: [
          { required: true, message: "请输入用药人年龄", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSuccessDelete() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      this.formData = {
        issueType: "",
        issueHospital: "",
        number: "",
        issueTime: "",
        department: "",
        diagnose: "",
        drugName: "",
        drugSpecification: "",
        count: "",
        usage: "",
        userName: "",
        userSex: "",
        userAge: "",
        notes: "",
      };
      this.isUpload = false;
      this.currentPage = 1;
      this.drugTotal = 0;
    },
    async handleSubmit() {
      if (!this.isUpload) {
        this.$notify({
          title: "注意!",
          type: "error",
          message: "请上传文件",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-error-title",
        });
        return;
      }
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          this.$nextTick(() => {
            const firstError = document.querySelector(".el-form-item.is-error");
            if (firstError) {
              firstError.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
          return;
        }
        this.loading = true;
        await this.$api.prescription.CreatePrescription(this.formData);
        this.loading = false;
        this.handleClose();
        this.$emit("success");
      });
    },
    handleClose() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      this.dialogCodeVisible = false;
      this.formData = {
        issueType: "",
        issueHospital: "",
        number: "",
        issueTime: "",
        department: "",
        diagnose: "",
        drugName: "",
        drugSpecification: "",
        count: "",
        usage: "",
        userName: "",
        userSex: "",
        userAge: "",
        notes: "",
      };
      this.isUpload = false;
      this.currentPage = 1;
      this.drugTotal = 0;
      this.$refs.DocumentUploadRef.reset();
    },
    handleSuccessUpload(data) {
      Object.assign(this.formData, data.analysisData);
      this.formData.drugName = data.analysisData.drugDetails[0].drugName;
      this.formData.drugSpecification =
        data.analysisData.drugDetails[0].drugSpecification;
      this.formData.count = data.analysisData.drugDetails[0].count;
      this.formData.usage = data.analysisData.drugDetails[0].usage;
      this.drugTotal = data.analysisData.drugDetails.length;
      this.currentPage = 1;
      this.isUpload = true;
      this.$forceUpdate();
    },
    handleCurrentChange(val) {
      if (!this.formData.drugDetails || !this.formData.drugDetails[val - 1]) {
        return;
      }
      this.formData.drugName = this.formData.drugDetails[val - 1].drugName;
      this.formData.drugSpecification =
        this.formData.drugDetails[val - 1].drugSpecification;
      this.formData.count = this.formData.drugDetails[val - 1].count;
      this.formData.usage = this.formData.drugDetails[val - 1].usage;
      this.$forceUpdate();
    },
    show() {
      this.dialogCodeVisible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          const dialogBody = document.querySelector(".create-left-content");
          if (dialogBody) {
            dialogBody.scrollTop = 0;
          }
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-form-item__label {
  display: inline-block !important;
  text-align: justify !important;
  text-align-last: justify !important;
  padding-right: 10px !important;
  position: relative !important;
}
::v-deep .el-form-item__label::before {
  position: absolute !important;
  left: -10px !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./createPrescription.scss";
</style>
